"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductSecurityCodeDetailSchema = exports.securityCodeType = exports.PlantDetailsSchema = exports.SireDetailSchema = exports.ConsigneeDetailSchema = exports.MobInductionSchema = exports.SireGroupInductionSchema = exports.AngusSireInductionSchema = exports.AssetInductionSSchema = exports.ExternalIdsSchema = exports.tokenTypesSchema = void 0;
const zod_1 = require("zod");
exports.tokenTypesSchema = zod_1.z.enum(['user', 'business', 'asset', 'consignment', 'sire', 'brand',
    'group', 'angusSire', 'angusMob', 'angusSireGroup', 'angusCalve', 'plant', 'assetProfile', 'promotion',
    'product', 'site', 'item', 'carton', 'pallet', 'consignee']);
exports.ExternalIdsSchema = zod_1.z.object({
    timestamp: zod_1.z.union([zod_1.z.date(), zod_1.z.string()]).optional(),
    angusTechUsername: zod_1.z.string().optional(),
    agliveToken: zod_1.z.string().optional(),
    rfid: zod_1.z.string().optional(),
    userId: zod_1.z.string().optional(),
    nlis_id: zod_1.z.string().optional(),
    angusId: zod_1.z.string().optional(),
    ceres_tag_esn: zod_1.z.string().optional(),
    ceres_tag_vid: zod_1.z.string().optional(),
    ceres_key: zod_1.z.string().optional(),
    brandId: zod_1.z.string().optional(),
    productId: zod_1.z.string().optional(),
    uuid: zod_1.z.string().optional(),
    uhf: zod_1.z.string().optional(),
    digirodeo_id: zod_1.z.string().optional(),
    consignmentId: zod_1.z.string().optional(),
});
exports.AssetInductionSSchema = zod_1.z.object({
    template: zod_1.z.literal('INDUCTION'),
    pic_name: zod_1.z.string(),
    pic_id: zod_1.z.string(),
    type: zod_1.z.literal('asset')
});
exports.AngusSireInductionSchema = zod_1.z.object({
    template: zod_1.z.literal(''),
    angusAuthToken: zod_1.z.string(),
    nlisUserId: zod_1.z.string(),
    nlisPassword: zod_1.z.string(),
    nlisEmail: zod_1.z.string(),
    type: zod_1.z.literal('angusSire')
});
exports.SireGroupInductionSchema = zod_1.z.object({
    template: zod_1.z.literal('SIRE GROUPS'),
    angusAuthToken: zod_1.z.string(),
    nlisUserId: zod_1.z.string(),
    nlisPassword: zod_1.z.string(),
    nlisEmail: zod_1.z.string(),
    type: zod_1.z.literal('angusSireGroup')
});
exports.MobInductionSchema = zod_1.z.object({
    template: zod_1.z.literal('RECORD ANIMALS'),
    angusAuthToken: zod_1.z.string(),
    nlisUserId: zod_1.z.string(),
    nlisPassword: zod_1.z.string(),
    nlisEmail: zod_1.z.string(),
    type: zod_1.z.literal('angusMob')
});
// Consignee
exports.ConsigneeDetailSchema = zod_1.z.object({
    receiverName: zod_1.z.string(),
    receiverEmail: zod_1.z.string(),
    receiverPhone: zod_1.z.string(),
    receiverCountry: zod_1.z.string(),
    receiverAddress: zod_1.z.string(),
    receiverPostCode: zod_1.z.string(),
    receiverTown: zod_1.z.string(),
    receiverState: zod_1.z.string(),
    receiverPIC: zod_1.z.string(),
});
// Sire
exports.SireDetailSchema = zod_1.z.object({
    acctId: zod_1.z.string(),
    sireId: zod_1.z.string(),
    picAddress: zod_1.z.string(),
    nlisUserId: zod_1.z.string(),
    businessId: zod_1.z.string(),
    externalIds: exports.ExternalIdsSchema
});
//Plant
exports.PlantDetailsSchema = zod_1.z.object({
    assetProfile: exports.ExternalIdsSchema,
    site: zod_1.z.string(),
    pic_id: zod_1.z.string()
});
//Security Code Token
exports.securityCodeType = zod_1.z.enum(['item', 'carton', 'pallet']);
exports.ProductSecurityCodeDetailSchema = zod_1.z.object({
    container: exports.securityCodeType,
    date: zod_1.z.string(),
    source: zod_1.z.object({
        companyName: zod_1.z.string(),
        companyNumber: zod_1.z.string(),
        creatorEmail: zod_1.z.string(),
    }),
    docId: zod_1.z.string(),
    product: exports.ExternalIdsSchema,
    showDeliveryHistory: zod_1.z.boolean().optional(),
    showMap: zod_1.z.boolean().optional(),
    isConfidential: zod_1.z.boolean().optional()
});
